"use client";

import { c as _c } from "react/compiler-runtime";
import { DistrictMapCarousel } from "@/components/features/district-map-carousel";
import { LayoutHeader } from "@/components/common/layout-header";
import type { PagebuilderType } from "@/lib/types";
import type { VisualType } from "@/lib/types";
import type { RichTextCondensed } from "@/lib/sanity/sanity.types";
import { getI18nString, getI18nValue, nullToUndefined } from "@/lib/utils";
import { useLocale } from "next-intl";
import type { Locale } from "@/i18n/config";
export type ImageFeatureCardMapBlockProps = PagebuilderType<"imageFeatureCardMap">;
export function ImageFeatureCardMapBlock(t0) {
  const $ = _c(13);
  const {
    layout
  } = t0;
  const locale = useLocale() as Locale;
  if (!layout) {
    return null;
  }
  const rawDistricts = "districts" in layout ? layout.districts : undefined;
  if (!rawDistricts || rawDistricts.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== locale || $[1] !== rawDistricts) {
    let t2;
    if ($[3] !== locale) {
      t2 = district_0 => ({
        key: district_0.key,
        headline: getI18nString(district_0.headline, "", locale) || "",
        bodyCopy: nullToUndefined(getI18nValue(district_0.bodyCopy, locale)) as RichTextCondensed | undefined,
        backgroundImage: nullToUndefined(district_0.backgroundImage) as VisualType | undefined,
        mapVisual: nullToUndefined(district_0.mapVisual) as VisualType | undefined,
        colour: undefined
      });
      $[3] = locale;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = rawDistricts.filter(_temp).map(t2);
    $[0] = locale;
    $[1] = rawDistricts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const districts = t1;
  let t2;
  if ($[5] !== layout || $[6] !== locale) {
    t2 = <LayoutHeader item={layout} locale={locale} />;
    $[5] = layout;
    $[6] = locale;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== districts) {
    t3 = <DistrictMapCarousel districts={districts} />;
    $[8] = districts;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <section data-testid="image-feature-card-map-block">{t2}{t3}</section>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(district) {
  return district.key;
}